import { render } from "./Standard_details.vue?vue&type=template&id=7efd13b6"
import script from "./Standard_details.vue?vue&type=script&lang=js"
export * from "./Standard_details.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__